import { Box, Button } from "@material-ui/core";
import { getHistory } from "@shoothill/core";
import { AppUrls } from "AppUrls";
import { Stores, StoresContext } from "Globals/Stores";
import { theme } from "Globals/Styles/AppTheme";
import { Page } from "Globals/Styles/LayoutStyles";
import AdminApplicantsListViewModel, { AdminApplicantTableDataModel } from "Globals/ViewModels/Applicant/AdminApplicantsListViewModel";
import { BinSVG } from "Globals/Views/IconSVGs/BinSVG";
import { TickSVG } from "Globals/Views/IconSVGs/TickSVG";
import MaterialTable, { MTableToolbar } from "material-table";
import { useObserver } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import styled from "styled-components";
import { DeleteApplicantModal } from "Views/Admin/Modal/DeleteApplicantModal";
import { NewApplicantRequestModal } from "Views/Admin/Modal/NewApplicantRequestModal";

const StyledRoundedButton = styled(Button)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    border-radius: 15px;
    padding: 9px 26px;
    background-color: ${theme.palette.hightownBlue.light};
    color: ${theme.palette.common.white};
    :hover {
        background-color: ${theme.palette.hightownBlue.light};
    }
`;
export interface IStatusCellProps {
    color: string;
}
export const StatusCell = styled.div<IStatusCellProps>`
    position: relative;
    display: flex;
    flex: 1 0 0;
    flex-direction: column;

    align-items: center;
    text-align: center;
    vertical-align: middle;

    padding: 5px 0;
    font-size: 12px;
    font-weight: 500;
    color: ${theme.palette.common.white};
    background-color: ${(props) => props.color};
`;
export const TablePageContent: any = styled(Box)`
    display: flex;
    flex-direction: column;
    padding: 0 5px;
    width: 100%;

    .MuiTableCell-root {
        font-size: 14px;
    }

    td {
        font-weight: normal !important;
    }

    > div {
        background-color: ${theme.palette.background.paper};
        box-shadow: unset !important;
    }
`;

export const AdminApplicantsListView: React.FC = () => {
    const storesContext = useContext<Stores>(StoresContext);
    const [viewModel] = useState(new AdminApplicantsListViewModel());
    const [newApplicantModal, setNewApplicantModal] = useState(false);
    const [deleteApplicantModal, setDeleteApplicantModal] = useState(false);
    const [userIdToDelete, setUserIdToDelete] = useState<string | null>(null);

    const modals = () => (
        <>
            {newApplicantModal && (
                <NewApplicantRequestModal isActive={newApplicantModal} confirmClose={() => setNewApplicantModal(false)} onCancel={() => setNewApplicantModal(false)} />
            )}
            {deleteApplicantModal && (
                <DeleteApplicantModal
                    isActive={deleteApplicantModal}
                    confirmClose={() => {
                        if (userIdToDelete) {
                            viewModel.deleteApplicant(userIdToDelete);
                        }
                        setDeleteApplicantModal(false);
                    }}
                    onCancel={() => {
                        setUserIdToDelete(null);
                        setDeleteApplicantModal(false);
                    }}
                />
            )}
        </>
    );

    const coluumns = [
        { title: "Name", field: "name" },
        { title: "Email address", field: "email" },
        { title: "Phone number", field: "phone" },
        {
            title: "Registration sent",
            field: "registrationSent",
            render: (rowData: AdminApplicantTableDataModel) => (
                <>
                    {rowData.registrationSent == true && (
                        <div className="tick">
                            <TickSVG color="#3AAA35" />
                        </div>
                    )}
                </>
            ),
        },
        { title: "Registered", field: "registeredDate" },
        {
            title: "No. of applications",
            field: "numberOfApplications",
            render: (rowData: AdminApplicantTableDataModel) => <>{rowData.numberOfApplications > 0 ? <>{rowData.numberOfApplications}</> : <>-</>}</>,
        },
        {
            title: "Status",
            field: "status",
            render: (rowData: AdminApplicantTableDataModel) => (
                <StatusCell style={{ textAlign: "center" }} color={storesContext.Domain.ApplicantStatusStore.getApplicantStatusColor(rowData.status)}>
                    <div>{storesContext.Domain.ApplicantStatusStore.getApplicantStatusName(rowData.status)}</div>
                </StatusCell>
            ),
        },
    ];

    const actions = [
        (rowData: AdminApplicantTableDataModel) => ({
            icon: () => <BinSVG />,
            tooltip: "Delete User",
            onClick: () => {
                setUserIdToDelete(rowData.id);
                setDeleteApplicantModal(true);
            },
        }),
    ];

    return useObserver(() => (
        <>
            <Page style={{ backgroundColor: "white" }}>
                <Box display="flex" width="100%">
                    <TablePageContent>
                        <MaterialTable
                            onSearchChange={(query) => {
                                if (viewModel.applicantUsers.length > 600) {
                                    viewModel.loadData(query);
                                }
                            }}
                            columns={coluumns}
                            data={viewModel.getTableData}
                            components={{
                                Toolbar: (props) => (
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <StyledRoundedButton onClick={() => setNewApplicantModal(true)}>Create new applicant</StyledRoundedButton>
                                        <MTableToolbar {...props} />
                                    </Box>
                                ),
                            }}
                            onRowClick={(event, rowData, togglePanel) => {
                                if (!rowData) return;
                                getHistory().push(AppUrls.Client.Admin.Applicant.replace(":applicantId?", rowData.id));
                            }}
                            title=""
                            actions={actions}
                            options={{
                                rowStyle: {
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                },
                                pageSize: 15,
                                pageSizeOptions: [10, 20, 50, 100],
                                emptyRowsWhenPaging: false,
                                actionsColumnIndex: -1,
                                debounceInterval: 800,
                            }}
                            localization={{
                                toolbar: {
                                    searchPlaceholder: "",
                                },
                            }}
                            isLoading={viewModel.IsLoading}
                        />
                    </TablePageContent>
                </Box>
            </Page>
            {modals()}
        </>
    ));
};
